import React, { useState } from 'react';
import styled from 'styled-components';
import SearchInput from '../input/SearchInput';
import SearchBtnHeader from '../button/SearchBtnHeader';
import {isMobileOnly} from 'react-device-detect';


const HeaderSearchBlock = styled.div`
    float: left;
    display: inline-block;
    position: relative;
    ${!isMobileOnly&&"margin-right: 25px"};
    vertical-align: middle;
`;

const HeaderSearch = ({onClick, onChange, enterPress, inputRef}) => {

    const [active, setActive] = useState(true);

    return (
        <HeaderSearchBlock>
            <SearchInput active={active}
                width={isMobileOnly?"168px":"224px"}
                height={isMobileOnly?'30px':'40px'}
                padding={isMobileOnly?" 9px 16px":" 0 56px 0 20px"}
                borderRadius="40px"
                bgColor="#fff"
                onChange = {onChange}
                inputRef = {inputRef}
                enterPress = {enterPress}/>
            <SearchBtnHeader onClick = {onClick}/>
        </HeaderSearchBlock>
    );
};

export default HeaderSearch;
